import {parseISO} from "date-fns";
import BookingService from "../services/bookings";

const {
    PAYMENTS_TYPES,
    PAYMENTS_REASONS
} = BookingService.enums;

/*
 * A full version of a Payment object
 */
export default class Payment {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.date = apiResponse.date ? parseISO(apiResponse.date) : null;
        this.paymentType = apiResponse.paymentType;
        this.reasonOfPayment = apiResponse.reasonOfPayment;
        this.amount = apiResponse.amount ? Number.parseFloat(apiResponse.amount) : null;
    }

    clone() {
        const payment = new Payment({});
        payment.id = this.id;
        payment.date = this.date ? new Date(this.date) : null;
        payment.paymentType = this.paymentType;
        payment.reasonOfPayment = this.reasonOfPayment;
        payment.amount = this.amount;
        return payment;
    }

    getTypeLabel(){
        const type = PAYMENTS_TYPES.find(t => t.value === this.paymentType);
        return type ? type.label : "altro"
    }

    getReasonLabel(){
        const reason = PAYMENTS_REASONS.find(r => r.value === this.reasonOfPayment);
        return reason ? reason.label : "altro"
    }
}